import { useEffect, useState } from 'react';
import { getConnectionPayload, getConnectionStatus, onConnectObservable, } from '../services/bridge-service';
/**
 * Get the initial payload sent by View (VM)
 * @returns Initial payload sent by View
 */
var useInitialPayload = function () {
    var _a = useState(getConnectionPayload().initialPayload), initialPayload = _a[0], setInitialPayload = _a[1];
    useEffect(function () {
        if (getConnectionStatus() === 'connected') {
            setInitialPayload(getConnectionPayload().initialPayload);
        }
        var handler = function (payload) {
            setInitialPayload(payload.initialPayload);
        };
        onConnectObservable.subscribe(handler);
        return function () {
            onConnectObservable.unsubscribe(handler);
        };
    }, []);
    return initialPayload;
};
export default useInitialPayload;
